import { useRouter } from '@bprogress/next';
import { useDrag } from '@use-gesture/react';
import { MouseEvent, RefObject, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { useRouteChangeContext } from '@/context/RouteChangeContext';
import { useUAContext } from '@/context/UAContext';
export const useDraggingScroll = (scrollRef: RefObject<HTMLDivElement | null>) => {
  const {
    device
  } = useUAContext();
  const matchesDesktop = useMediaQuery('(min-width: 1024px)');
  const disableDrag = !matchesDesktop || device !== 'desktop_browser';
  const router = useRouter();
  const {
    setIsRouteLoading
  } = useRouteChangeContext();
  const [isDragging, setIsDragging] = useState(false);
  const bind = useDrag(({
    down,
    movement: [mx],
    memo = scrollRef?.current?.scrollLeft || 0
  }) => {
    if (disableDrag) {
      return memo;
    }
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = memo - mx * 4;
    }
    setIsDragging(down);
    return memo;
  }, {
    axis: 'x',
    eventOptions: {
      passive: false
    },
    filterTaps: true
  });
  const onMouseDown = (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    // 💅🏻 Currently only allow dragging on images, links
    // 💅🏻 Can be extended to other elements if needed
    if (!disableDrag && (target.tagName === 'IMG' || target.tagName === 'A')) {
      e.preventDefault();
      setIsDragging(true);
    }
  };
  const onMouseUp = (e_0: MouseEvent) => {
    // 🥷🏼 Workaround for firefox click not working
    if (isDragging) {
      const target_0 = e_0.target as HTMLElement;
      switch (target_0.tagName) {
        case 'IMG':
          {
            const closestLink = target_0.closest('a');
            if (closestLink) {
              setIsRouteLoading(true);
              router.push(closestLink.href);
            }
            break;
          }
        case 'A':
          {
            setIsRouteLoading(true);
            router.push((target_0 as HTMLAnchorElement).href);
            break;
          }
        default:
          break;
      }
    }
    if (!disableDrag) {
      setTimeout(() => setIsDragging(false), 50);
    }
  };
  return {
    bind,
    disableDrag,
    isDragging,
    onMouseDown,
    onMouseUp
  };
};